<template>
  <section class="product-container">
    <header>
      <inline-svg
        v-if="!singleProduct"
        src="/images/icons/chevron-left-solid.svg"
        class="divider"
      ></inline-svg>
      <span v-if="!singleProduct" class="back-btn pointer" @click="$emit('show-products')">
        Terug
      </span>
      <span>
        {{ product.title }}
      </span>
      <div class="more-button" v-if="!hideTemplatesMenu">
        <spec-button
          :title="'Instellingen'"
          :selected="false"
          @action="showSaveTemplate = !showSaveTemplate"
          :inactive="false"
          :has-sub="true"
        >
        </spec-button>
        <spec-sub-menu
          v-if="showSaveTemplate"
          menu-title="Instellingen bewaren"
          @close="closeSaveTemplate"
        >
          <template #default>
            <save-template-form
              @save="saveTemplate"
              @cancel="closeSaveTemplate"
              :format="this.selectedFiles[0].format"
            />
          </template>
        </spec-sub-menu>
      </div>
    </header>
    <product-specs-header
      :product="product"
      :selected-files="selectedFiles"
      :standalone="standalone"
      :required-missing="selectedFiles.some((f) => fileHasRequiredSpecsMissing(f))"
      @add-to-cart="addToCart"
    ></product-specs-header>

    <div
      class="menu-group"
      :class="{ 'menu-group--single': visibleMenus.length === 1 }"
      v-for="(menuGroup, index) in visibleMenus"
      :key="index"
    >
      <menu-group
        :menu-group="menuGroup"
        :selected-specs="selectedMenuGroupSpecs(menuGroup)"
        :selected-files="selectedFiles"
        :open="menuOpenIndex === index"
        :show-toggle="visibleMenus.length > 1"
        :standalone="standalone"
        @toggleMenu="
          (arg) => {
            setMenuOpenIndex(index, arg)
          }
        "
      ></menu-group>
    </div>

    <footer-bar
      v-if="product.footerBar && typeof product.footerBar === 'object'"
      :footer-bar="product.footerBar"
      :selected-files="selectedFiles"
      @file-type-changed="onFileTypeChanged"
    />
  </section>
</template>

<script>
import { mapStores } from 'pinia'
import { useProductOrderStore } from '../ProductOrder.store'
import { useFileListStore } from '@/stores/FileList.store'
import MenuGroup from './productSpecs/MenuGroup.vue'
import SpecButton from '@/components/ui/SpecButton.vue'
import SpecSubMenu from '@/components/ui/SpecSubMenu.vue'
import SaveTemplateForm from './SaveTemplateForm.vue'
import ProductSpecsHeader from './productSpecs/ProductSpecsHeader.vue'
import FooterBar from './productSpecs/FooterBar.vue'
import ProductOrderMixin from '../ProductOrderMixin'

export default {
  props: ['product', 'selectedFiles', 'standalone', 'singleProduct'],
  components: {
    MenuGroup,
    SpecButton,
    SpecSubMenu,
    SaveTemplateForm,
    ProductSpecsHeader,
    FooterBar
  },
  mixins: [ProductOrderMixin],
  data() {
    return {
      menu: '',
      curMenu: 0,
      menuOpenIndex: 0,
      showSaveTemplate: false
    }
  },
  methods: {
    onFileTypeChanged() {
      const selectedFileNames = this.selectedFiles.map((f) => f.fileName)
      let changed = true
      let maxIterations = 5
      while (changed && maxIterations-- > 0) {
        const specsBefore = JSON.stringify(
          this.fileList.fileList.find((f) => selectedFileNames.includes(f.fileName))
            ?.productSpecs?.specs
        )
        this.checkAndRemoveHiddenMenuSpecs(selectedFileNames)
        this.checkAndRestoreVisibleMenuDefaults(selectedFileNames)
        const specsAfter = JSON.stringify(
          this.fileList.fileList.find((f) => selectedFileNames.includes(f.fileName))
            ?.productSpecs?.specs
        )
        changed = specsBefore !== specsAfter
      }
    },
    closeSaveTemplate() {
      this.showSaveTemplate = false
    },
    async saveTemplate(templateName, isDef) {
      const newSpecs = {
        title: templateName,
        specs: {
          title: this.product.title
        }
      }
      this.selectedFiles[0].productSpecs.specs.forEach((spec) => {
        if (!newSpecs.specs[spec.title]) {
          newSpecs.specs[spec.title] = []
        }
        newSpecs.specs[spec.title].push(spec.optionTitle)
      })
      const newTemplate = {
        name: templateName,
        default: isDef,
        productSpecs: newSpecs,
        format: this.selectedFiles[0].format || 'Als bestand'
      }

      await this.productOrderStore.saveUserTemplate(newTemplate)

      this.closeSaveTemplate()
    },
    setMenuOpenIndex(index, open) {
      if (open) {
        this.menuOpenIndex = -1
      } else {
        this.menuOpenIndex = index
      }
    },
    addToCart() {
      this.$emit('add-to-cart')
    },
    selectedMenuGroupSpecs(menuGroup) {
      let activeFileSpecs = this.selectedFiles[0].productSpecs.specs
      let activeGroupSpecs = []

      activeFileSpecs.every((spec) => {
        if (spec.title == menuGroup.title) {
          activeGroupSpecs.push(spec)
        }
        return spec.optionGroupName === 'toggleOptions' &&
          spec.optionName === 'disabled' &&
          spec.title === menuGroup.title
          ? false
          : true
      })

      return activeGroupSpecs
    }
  },
  computed: {
    ...mapStores(useProductOrderStore, useFileListStore),
    visibleMenus() {
      // return this.menus
      const pagesTotal =
        this.selectedFiles[0].pagesColour + this.selectedFiles[0].pagesBW

      let menusToShow = []

      for (let i = 0; i < this.product.menus.length; i++) {
        const menu = this.product.menus[i]

        // Check hideWhen conditions
        if (this.menuHideCheck(menu, this.selectedFiles)) {
          continue
        }

        if (menu.hidden) {
          continue
        } else if (
          menu.minPagesRequired &&
          pagesTotal < menu.minPagesRequired
        ) {
          continue
        } else if (menu.fileTypeRequired) {
          // Check if required file type exists in fileList
          const requiredFileExists = this.selectedFiles[0].productSpecs.files?.some(
            (file) => file.type === menu.fileTypeRequired
          )
          if (!requiredFileExists) {
            continue
          }
          menusToShow.push(menu)
        } else {
          menusToShow.push(menu)
        }
      }
      return menusToShow

      /*       return this.product.menus.filter(
        (menu) => !menu.hidden || pagesTotal > menu.minPagesRequired
      ) */
    },
    hideTemplatesMenu() {
      return this.rootStore.theme.customFields.printOrder?.hideUserTemplates
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  height: 19px;

  span {
    font-weight: 600;
    font-size: 0.875rem;
    color: var(--text-color);
    margin-bottom: 0px;
    display: inline-block;
  }
}

.menu-group {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  &--single {
    flex: 1;
    display: flex;
    flex-direction: column;

    :deep(.group-container) {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    :deep(.menu-group-holder) {
      flex: 1;
      overflow-y: auto;
    }
  }
}

.product-container {
  padding: 25px 25px 25px;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: inherit;
}

.divider {
  height: 10px;
  margin: 0 1px 0 6px;

  :deep(g) {
    fill: var(--arch-color);
  }
}

.back-btn {
  color: var(--arch-color);
  font-weight: 600;
  margin-right: 13px;
}

.more-button {
  margin-left: auto;
  position: relative;
}

.footer-bar {
  margin-top: auto;
}
</style>
